import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../services/spinner.service';
import { DownloadService } from '../../services/download.service';
import { SnackbarService } from '../../services/snackbar.service';
import { ManagersAgreementsContributionsDisDialogComponent } from '../managers-agreements-contributions-dis-dialog/managers-agreements-contributions-dis-dialog.component';
import { ManagersAgreementsManagerSelectionDialogComponent } from '../managers-agreements-manager-selection-dialog/managers-agreements-manager-selection-dialog.component';
import { ManagersAgreementsContributionsDisDeclineDialogComponent } from '../managers-agreements-contributions-dis-cancel-dialog/managers-agreements-contributions-dis-cancel-dialog.component';
import { FormatCurrencyPipe } from '../../share/components/pipe/FormatCurrency.pipe';

import {
  AportacionDiAcuerdosGestoresControllerService,
  SolicitudNimaGestoresDTO,
  AportacionDIEstadoControllerService,
  AportacionDIEstadoDTO,
  PageDTOAportacionDIAcuerdosGestoresDTO,
  AportacionDIAcuerdosGestoresFilterDTO,
  DiccionarioControllerService,
  DiccionarioElementoDTO,
  CodigoLerControllerService,
  CodigoLerFilterDTO,
  OperacionGestionControllerService,
  CodigoOperacionFilterDTO,
  PoseedorEstadoControllerService,
  GestoresResiduosEstadosControllerService,
  PlataformaOrigenControllerService
} from 'api-rest';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import moment from 'moment';
import { CombosService } from '../../services/combos.service';
import { ParseCurrencyPipe } from '../../share/components/pipe/ParseCurrency.pipe';
import { IndirectAgreementContributionsDisUploadDialogComponent } from '../indirect-agreement-contributions-dis-upload-dialog/indirect-agreement-contributions-dis-upload-dialog.component';
import { ManagersAgreementsContributionsDisPreviewDialogComponent } from '../managers-agreements-contributions-dis-dialog/managers-agreements-contributions-dis-preview-dialog.component';
import swal from 'sweetalert2';
import { GeTableComponent } from '../../share/components/ge-table.component';

@Component({
  selector: 'app-managers-agreements-contributions-dis',
  templateUrl: './managers-agreements-contributions-dis.component.html',
  styleUrls: ['./managers-agreements-contributions-dis.component.scss'],
})
export class ManagersAgreementsContributionsDisComponent implements OnInit {
  @ViewChild(GeTableComponent) geTable?: GeTableComponent;

  tipoAcceso: string | null = null;
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;
  nimaPoseedorArray: any[] = [];
  poseedorArray: any[] = [];
  nimaGestorArray: any[] = [];
  globalIdGestores: any[] = [];
  gestorArray: any[] = [];
  gestoresArray: any[] = [];
  estadoArray: any[] = [];
  estadoPoseedorArray: any[] = [];
  estadoGestorArray: any[] = [];
  codigoLerArray: any[] = [];
  operacionGestionArray: any[] = [];
  plataformaOrigenArray: any[] = [];
  origenArray: { value: string; label: string }[] = [
    { value: 'POSEEDOR', label: 'Poseedores finales' },
    { value: 'SDDRCA', label: 'SDDR Abierto' },
  ];
  cargadoPorArray: any[] = [];
  orden: DiccionarioElementoDTO[] = [];
  mostrarFiltros: boolean = true;
  headArray: any = [
    {
      Head: 'ID. Ges.',
      FieldName: 'gestorResiduo',
      Attribute: 'id',
      tooltipHeader: 'ID DEL GESTOR',
    },
    {
      Head: 'Gestor',
      FieldName: 'gestorResiduo',
      Attribute: 'razonSocial',
      tooltipHeader: 'RAZÓN SOCIAL DEL GESTOR',
    },
    {
      Head: 'Documento',
      FieldName: 'gestorResiduo',
      Attribute: 'codigoDocumento',
      tooltipHeader: 'DOCUMENTO DEL GESTOR (NIF, NIE)',
    },
    {
      Head: 'NIMA Ges.',
      FieldName: 'gestorResiduo',
      Attribute: 'nima',
      tooltipHeader: 'NIMA DEL GESTOR',
    },
    {
      Head: 'NIMA Pos.',
      FieldName: 'poseedor',
      Attribute: 'nima',
      tooltipHeader: 'NIMA DEL POSEEDOR',
    },
    {
      Head: 'Fecha de aport',
      FieldName: 'fechaMAportacion',
          tooltipHeader: 'FECHA APORTACIÓN',
    },
    {
      Head: 'Fecha de acep.',
      FieldName: 'fechaMAceptacion',
      tooltipHeader: 'FECHA ACEPTACIÓN',
    },
    {
      Head: 'DI/FS',
      FieldName: 'documentoIdentificacion',
        tooltipHeader: 'DOC. IDENTIFICACIÓN/FULL SEGUIMENT'
    },
    // {
    //   Head: 'Cód. LER y descrip.',
    //   FieldName: 'descripcionMCodLer',
    //    tooltipHeader: 'CÓDIGO LER Y DESCRIPCIÓN',
    //   renderValue: (item: any) => {
    //     const tipoCodigo = item?.codigoLer?.tipoCodigo ?? '';
    //     const descripcion = item?.codigoLer?.descripcion ?? '';
    //     return `${tipoCodigo} ${descripcion}`.trim();
    //   },
    // },
    {      Head: 'Cód. LER y descrip.',
      FieldName: 'descripcionMCodLer',
      tooltipHeader: 'CÓDIGO LER Y DESCRIPCIÓN',
      Tooltip: true,
      Maxtext: 25,
    },
    {
      Head: 'Op. Ges.',
      FieldName: 'descripcionOperacionGes',
      tooltipHeader: 'OPERACIÓN DE GESTIÓN',
      Tooltip: true,
      Maxtext: 25,
    },
{
      Head: 'Cant. KG',
      FieldName: 'cantidadGestionada',
      tooltipHeader: 'CANTIDAD NETA GESTIONADA (KG)',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.cantidadGestionada),

    },
    {
      Head: 'Est aport',
      FieldName: 'estado',
      Attribute: 'descripcionCorta',
      tooltipHeader: 'ESTADO APORTACIÓN',
    },
{
      Head: 'Cargado por',
      FieldName: 'esCreadoPoseedor',
      tooltipHeader: 'CARGADO POR',
      renderValue: ((item: any) => {
         if(item.esCreadoPoseedor){
          return 'Poseedor';
         }else{
            //if(item.origen === 'POSEEDOR'){
            //  return 'Gestor';
            //}else{
            //  return 'Acondicionador';
            //}
            return 'Gestor';
         }
      })
    },
    {
      Head: 'Plat. origen',
      FieldName: 'plataformaOrigen',
      Attribute: 'descripcion',
      tooltipHeader: 'PLATAFORMA ORIGEN',
    },
    {
      Head: 'Est. gest.',
      FieldName: 'gestorResiduo',
      Attribute: 'gestoresResiduosEstado.descripcionCorta',
      tooltipHeader: 'ESTADO GESTOR',
    },
    {
      Head: 'Acc.',
      FieldName: 'actions',
      tooltipHeader: 'ACCIONES',
      check: this.canAccessCrearAutoFactura(),
      showCheckedAll: this.canAccessCrearAutoFactura(),
      tooltipCheckedAll: 'Seleccionar todos',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle ',
          show: {
            params: 'canAccessView',
            accion: 'view',
          },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Eliminar',
          show: {
            params: 'canAccessDelete',
            accion: 'delete',
          },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'preview',
              name: 'Vista previa',
              show: { params: 'canAccessPreview', accion: 'preview' },
            },
            {
              nameButton: 'send',
              name: 'Enviar aportación ',
              show: {
                params: 'canAccessSend',
                accion: 'send',
              },
            },
            {
              nameButton: 'accept',
              name: 'Aceptar aportación',
              show: { params: 'canAccessAccept', accion: 'accept' },
            },
            {
              nameButton: 'cancel',
              name: 'Cancelar aportación',
              show: { params: 'canAccessCancel', accion: 'cancel' },
            },
            {
              nameButton: 'correccionEnvalora',
              name: ' Corrección envalora',
              show: { params: 'canAccessCorreccionEnvalora', accion: 'correccionEnvalora' },
            },
          ],
        },
      ],
      width: '18',
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  searchForm: FormGroup;

  updateList: boolean = false;


  listaGestores = this.environment.urlBackCore + 'api/v1/acuerdo-indirecto/gestores/byUser';
  //listaGestores = this.environment.urlBackCore + 'api/v1/acuerdos-gestores/gestores/byUser';
  poseedorEndpoint: string =
    this.environment.urlBackPoseedores + `api/v1/poseedores/poseedor`;
  gestorEndpoint: string =
    this.environment.urlBackPoseedores + `api/v1/acuerdo-indirecto/aportaciondi-gestor`;

  //defaultGestoresParameters = { 'gestoresResiduosEstado.id': 2};

  rolesGestor: any[] = [];
  rolesAiGestor: any[] = [];
  rolesEnvalora: any[] = [];
  mostrarPlataformaOrigen: boolean = false;
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private downloadService: DownloadService,
    private snackBarSrv: SnackbarService,
    private aportacionDiAcuerdosGestoresService: AportacionDiAcuerdosGestoresControllerService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private AportacionDIEstadoControllerService: AportacionDIEstadoControllerService,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private parseCurrencyPipe: ParseCurrencyPipe,
    public comboService: CombosService,
    private poseedorEstadoControllerService: PoseedorEstadoControllerService,
    private codigoLerControllerService: CodigoLerControllerService,
    private operacionGestionControllerService: OperacionGestionControllerService,
    @Inject(DiccionarioControllerService)
    private diccionarioControllerService: DiccionarioControllerService,
    private plataformaOrigenControllerService: PlataformaOrigenControllerService,
    private gestoresResiduosEstadosControllerService: GestoresResiduosEstadosControllerService,
  ) {
    const fechadesde = `01/01/${moment().format('YYYY')}`;
    const [dia, mes, año] = fechadesde.split('/').map(Number);
    const fechaInicialDesde = new Date(año, mes - 1, dia);

    const fechaActual = new Date();
    const roleEntities = (this.authService.user as any).roleEntities;
    this.rolesGestor = roleEntities?.filter(
      (roleEntity: any) => roleEntity.role == 'AI-APORT-AUTOFACT'
    );
    this.rolesAiGestor = roleEntities?.filter(
      (roleEntity: any) =>
        roleEntity.role === 'AI_GESTOR' || roleEntity.role === 'AI-GESTOR'
    );
    this.rolesEnvalora = roleEntities?.filter(
      (roleEntity: any) => roleEntity.role == 'AI-ENV-GEST' || roleEntity.role == 'AI-ENV-CONS'
    );

    this.searchForm = this.formBuilder.group({
      gestor: [{ value: null, disabled: false }],
      idgestor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      idposeedor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      codigo_documento: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],

      nima_gestor: [{ value: null, disabled: false }],
      codigo_documento_gestor: [{ value: null, disabled: false }],
      fecha_desde: [
        { value: fechaInicialDesde, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fecha_hasta: [
        { value: fechaActual, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fecha_aport_desde: [
        { value: null, disabled: false },
      ],
      fecha_aport_hasta: [
        { value: null, disabled: false },
      ],
      doc_identificacion: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      estadoPoseedor: [{ value: null, disabled: false }],
      estadoGestor: [{ value: null, disabled: false }],
      codigoLer: [{ value: null, disabled: false }],
      operacionGestion: [{ value: null, disabled: false }],
      origen: [{ value: null, disabled: false }],
      plataformaOrigen: [{ value: null, disabled: false }],
      cargadoPor: [{ value: null, disabled: false }],
      cantidadDesde: [{ value: null, disabled: false }],
      cantidadHasta: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
      fechaAceptacion: [{ value: null, disabled: false }],
      poseedor: [{ value: null, disabled: false }],
    });
  }

  ngOnInit() {
    this.normalizeHeaderTooltips();
    this.tipoAcceso =
      this.rolesGestor?.length > 0 || this.rolesAiGestor?.length > 0
        ? 'gestor'
        : null;
    this.comboEstados();
    this.comboEstadosPoseedor();
    this.comboOrden();
    this.comboCodigoLer();
    this.comboPlataformaOrigen();
    this.comboGestoresEstado();
     this.buscarOperacionesGestion();
    this.cargadoPorArray = this.comboService.getTiposUsuario().filter((x: any) => x.id === 'GESTOR' || x.id === 'POSEEDOR');

    this.route.queryParams.subscribe((params) => {
      if (params['tipo']) {
        this.tipoAcceso = params['tipo'];
      }
    });

    this.searchForm.get('codigoLer')?.valueChanges.subscribe(() => {
      this.buscarOperacionesGestion();
    });
  }

  private normalizeHeaderTooltips(): void {
    this.headArray = (this.headArray ?? []).map((item: any) => {
      if (!item) {
        return item;
      }

      const headerTooltip = item.tooltipHeader ?? item.toolTipHeader ?? item.Head;
      return {
        ...item,
        tooltipHeader: headerTooltip,
        toolTipHeader: headerTooltip,
      };
    });
  }

  checked(event: any) {
    if (!this.isEstadoAceptada(event?.estado)) {
      this.snackBarSrv.showSnackBar(
        'Solo se pueden prefacturar aportaciones en estado Aceptada',
        'error'
      );
      event.checked = null;
      this.gridArray = this.gridArray.map((item) => ({ ...item }));
      if (this.geTable) {
        this.geTable.uncheckSelectAllHeader();
        setTimeout(() => {
          this.geTable!.uncheckSelectAllHeader();
        });
      }
    }
  }

  selectAll(list: any[]) {
    const isChecking = Array.isArray(list) && list.some((item) => item?.checked === true);
    if (!isChecking) {
      if (this.geTable) {
        this.geTable.uncheckSelectAllHeader();
      }
      this.gridArray = [...list];
      return;
    }

    const hasInvalidItems =
      list.length === 0 ||
      list.some((item) => (item?.estado ? !this.isEstadoAceptada(item.estado) : true));

    if (hasInvalidItems) {
      this.snackBarSrv.showSnackBar(
        'Solo se pueden prefacturar aportaciones en estado Aceptada',
        'error'
      );
      list.forEach((item) => (item.checked = false));
      if (this.geTable) {
        this.geTable.uncheckSelectAllHeader();
        setTimeout(() => {
          this.geTable!.uncheckSelectAllHeader();
        });
      }
    }

    this.gridArray = list.map((item) => ({ ...item }));
  }

  private isEstadoAceptada(estado: any): boolean {
    const estadoId = estado?.id ?? estado;
    const estadoDescripcion = (estado?.descripcion ?? estado?.descripcionCorta ?? '')
      .toString()
      .trim()
      .toLowerCase();

    return estadoId === 3 || estadoDescripcion.includes('acept');
  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  private getBackendFilter() {
    let formatDateDesde = moment(
      new Date(this.searchForm.get('fecha_desde')?.value)
    ).format('YYYY-MM-DD');

    formatDateDesde = formatDateDesde;

    let formatDateHasta = moment(
      new Date(this.searchForm.get('fecha_hasta')?.value)
    ).format('YYYY-MM-DD');

    formatDateHasta = formatDateHasta;

    //Fecha aportacion
    let fechaAportacion : string[] | undefined;
    if(this.searchForm.get('fecha_aport_desde')?.value || this.searchForm.get('fecha_aport_hasta')?.value){
      fechaAportacion = [];
      if(this.searchForm.get('fecha_aport_desde')?.value){
        let formatDateAportDesde = moment(
          new Date(this.searchForm.get('fecha_aport_desde')?.value)
        ).format('YYYY-MM-DD');

        //formatDateAportDesde = `gte(${formatDateAportDesde})`;
        fechaAportacion.push(formatDateAportDesde);
      }
      if(this.searchForm.get('fecha_aport_hasta')?.value){
        let formatDateAportHasta = moment(
          new Date(this.searchForm.get('fecha_aport_hasta')?.value)
        ).format('YYYY-MM-DD');

        // formatDateAportHasta = `lte(${formatDateAportHasta}) `;
        fechaAportacion.push(formatDateAportHasta);
      }
    }

    const selectGestores = this.searchForm.get('gestor')?.value;
    const selectCodigosLer = this.searchForm.get('codigoLer')?.value;
    const selectOperaciones = this.searchForm.get('operacionGestion')?.value;
    const selectEstado = this.searchForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    const selectEstadoPoseedor = this.searchForm.get('estadoPoseedor')?.value;
    const estadoPoseedorId = (selectEstadoPoseedor ?? []).map((objeto: any) =>
      objeto.id !== undefined ? objeto.id : objeto
    );

    const selectEstadoGestor = this.searchForm.get('estadoGestor')?.value;
    const estadoGestorId = (selectEstadoGestor ?? []).map((objeto: any) =>
      objeto.id !== undefined ? objeto.id : objeto
    );

    const codigoLerId = (selectCodigosLer ?? []).map((objeto: any) =>
      objeto.id !== undefined ? objeto.id : objeto
    );

    const operacionGestionId = (selectOperaciones ?? []).map((objeto: any) =>
      objeto.id !== undefined ? objeto.id : objeto
    );

    const cantidadDesde = this.searchForm.get('cantidadDesde')?.value|| undefined;
    const cantidadHasta = this.searchForm.get('cantidadHasta')?.value|| undefined;

    let backendFilter: any = {
      poseedor: {
        id: (this.searchForm.get('poseedor')?.value as any[] | null)?.map((objeto: any) =>
          objeto?.id !== undefined ? objeto.id : objeto
        ),
        estado: { id: estadoPoseedorId },
      } as any,
      gestorResiduo: {
        id: [selectGestores?.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        ),
        this.searchForm.get('idgestor')?.value
        ],
        nima: this.searchForm.get('nima_gestor')?.value,
        razonSocial: this.searchForm.get('razon_social')?.value ? this.searchForm.get('razon_social')?.value.trim() : undefined,
        codigoDocumento: this.searchForm.get('codigo_documento_gestor')?.value,
      },
      fechaAceptacion: [formatDateDesde, formatDateHasta],
      fechaAportacion: fechaAportacion,
      documentoIdentificacion:  this.searchForm.get('doc_identificacion')?.value ? this.searchForm.get('doc_identificacion')?.value.trim() : undefined,
      estado: { id: selectEstadosId },
      codigoLer: { id: codigoLerId } as any,
      operacionGestion: { id: operacionGestionId } as any,
      origen: this.searchForm.get('origen')?.value,
      plataformaOrigen: this.searchForm.get('plataformaOrigen')?.value,
      esCreadoPoseedor: this.searchForm.get('cargadoPor')?.value === 'POSEEDOR' ? true : (this.searchForm.get('cargadoPor')?.value === 'GESTOR' ? false : undefined),
      cantidadDesde: cantidadDesde,
      cantidadHasta: cantidadHasta,
    };

    if (this.searchForm.get('codigo_documento')?.value) {
      (backendFilter as any).poseedor = {
        ...(backendFilter as any).poseedor,
        codigoDocumento: this.searchForm.get('codigo_documento')?.value,
      };
    }

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    return { backendFilter, page, size: this.pageSize };
  }

  // exportarExcel() {
  //   const { backendFilter, page, size } = this.getBackendFilter();
  //   this.aportacionDiAcuerdosGestoresService
  //     .exportXlsx3                                                                                                                                                                                                                                                                                                        (backendFilter, 'response')
  //     .subscribe((res: any) => {
  //       this.downloadService.exportModal();
  //       // const filename = this.downloadService.getFileName(
  //       //   res.headers,
  //       //   'ExportacionDi.csv'
  //       // );
  //       // this.downloadService.downloadCSV(res.body!, filename!);
  //     });
  // }

   exportarExcel() {

    if (this.canViewResource('AI-ENV-GEST') || this.canViewResource('AI-ENV-CONS')) {
      this.descargaAsincrona();
    } else {
      const formatDateDesde = moment(new Date(this.searchForm.get('fecha_desde')?.value));
      const formatDateHasta = moment(new Date(this.searchForm.get('fecha_hasta')?.value));
      const diffDays = formatDateHasta.diff(formatDateDesde, 'days');

      if (diffDays > 366 && !(this.canViewResource('AI-ENV-GEST') || this.canViewResource('AI-ENV-CONS'))) {
        this.snackBarSrv.showSnackBar(
          'El periodo de exportación no puede ser superior a un año',
          'error'
        );
        return;
      }

      this.descargasincrona();
    }

  }

descargaAsincrona(){
          const { backendFilter, page, size } = this.getBackendFilter();
    this.aportacionDiAcuerdosGestoresService
      .exportXlsx3                                                                                                                                                                                                                                                                                                        (backendFilter, 'response')
      .subscribe((res: any) => {
        this.downloadService.exportModal();
      });
    }

         descargasincrona(){
          const { backendFilter, page, size } = this.getBackendFilter();
          this.spinnerSrv.loadingShow();
    this.aportacionDiAcuerdosGestoresService
      .exportXlsx3                                                                                                                                                                                                                                                                                                        (backendFilter, 'response')
      .subscribe((res: any) => {
        // this.downloadService.exportModal();
        const filename = this.downloadService.getFileName(
          res.headers,
          'ExportacionDi.xlsx'
        );
        this.downloadService.downloadBlob(res.body!, filename!);
        this.spinnerSrv.loadingHide();
      });
    }
     confirmarBottonExportar() {

        swal.fire({
          text: 'Para descargar el detalle de las aportaciones registradas, debe confirmar que garantiza la confidencialidad y el correcto tratamiento de los datos de sus clientes.',
          icon: 'question',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Confirmar',
          denyButtonText: 'Cancelar',
          allowOutsideClick: false,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.exportarExcel();
          }
        });
      }
  getGestorDescriptionObRazonSocial(obj: any) {
    const gestor = obj?.gestorResiduo ?? obj?.gestoresResiduos ?? obj;
    return gestor?.razonSocial ?? '';
  }

  getGestorDescription(obj: any) {

    const gestor = obj?.gestorResiduo ?? obj?.gestoresResiduos ?? obj;
    return (gestor?.razonSocial ?? '') + ' - ' + (gestor?.nima ?? '') + ' - ' + (gestor?.centro ?? '');
  }

  getGestorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: searchterm,
      descripcion: searchterm,
      'estado.id': 4,
    };
  }

  clearSearcher() {
    this.searchForm.reset();
    const fechadesde = `01/01/${moment().format('YYYY')}`;
    const [dia, mes, año] = fechadesde.split('/').map(Number);
    this.searchForm.patchValue({
      fecha_desde: new Date(año, mes - 1, dia),
      fecha_hasta: new Date(),
    });
    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v: any) => {
          if (typeof v === 'object' && typeof filtro.value === 'object') {
            const currentId = v?.id ?? v;
            const targetId = filtro.value?.id ?? filtro.value;
            return currentId !== targetId;
          }
          return v !== filtro.value;
        });
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }

    this.pageNumber = 0;
    //this.searchData(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const gestores = this.searchForm.get('gestor')?.value as any[];
    if (gestores?.length) {
      gestores.forEach((gestor: any) => {
        const label =
          typeof gestor === 'object' && gestor !== null
            ? this.getGestorDescription(gestor)
            : String(gestor);
        filtros.push({ label, campo: 'gestor', value: gestor });
      });
    }

    const docGestor = this.searchForm.get('codigo_documento_gestor')?.value;
    if (docGestor?.trim()) filtros.push({ label: docGestor.trim(), campo: 'codigo_documento_gestor' });

    const estadosGestor = this.searchForm.get('estadoGestor')?.value as any[];
    if (estadosGestor?.length) {
      estadosGestor.forEach((est: any) => {
        filtros.push({ label: est.descripcionCorta ?? String(est), campo: 'estadoGestor', value: est });
      });
    }
    

    const idGestor = this.searchForm.get('idgestor')?.value;
    if (idGestor) {
      filtros.push({ label: ` ${idGestor}`, campo: 'idgestor' });
    }

    const poseedores = this.searchForm.get('poseedor')?.value as any[];
    if (poseedores?.length) {
      poseedores.forEach((p: any) => {
        const label =
          typeof p === 'object' && p !== null
            ? this.getPoseedorDescription(p)
            : String(p);
        filtros.push({ label, campo: 'poseedor', value: p });
      });
    }

    const idPoseedor = this.searchForm.get('idposeedor')?.value;
    if (idPoseedor) {
      filtros.push({ label: ` ${idPoseedor}`, campo: 'idposeedor' });
    }

    const estadosPoseedor = this.searchForm.get('estadoPoseedor')?.value as any[];
    if (estadosPoseedor?.length) {
      estadosPoseedor.forEach((est: any) => {
        filtros.push({ label: est.descripcionCorta ?? String(est), campo: 'estadoPoseedor', value: est });
      });
    }

    const codigoDocumento = this.searchForm.get('codigo_documento')?.value;
    if (codigoDocumento?.trim()) {
      filtros.push({ label: `${codigoDocumento.trim()}`, campo: 'codigo_documento' });
    }

    const razonSocial = this.searchForm.get('razon_social')?.value;
    if (razonSocial?.trim()) {
      filtros.push({ label: ` ${razonSocial.trim()}`, campo: 'razon_social' });
    }

    const nimaGestor = this.searchForm.get('nima_gestor')?.value;
    if (nimaGestor?.trim()) {
      filtros.push({ label: ` ${nimaGestor.trim()}`, campo: 'nima_gestor' });
    }

    const fechaDesde = this.searchForm.get('fecha_desde')?.value;
    if (fechaDesde) {
      filtros.push({
        label: ` ${moment(new Date(fechaDesde)).format('DD/MM/YYYY')}`,
        campo: 'fecha_desde',
      });
    }

    const fechaHasta = this.searchForm.get('fecha_hasta')?.value;
    if (fechaHasta) {
      filtros.push({
        label: ` ${moment(new Date(fechaHasta)).format('DD/MM/YYYY')}`,
        campo: 'fecha_hasta',
      });
    }

    const fechaAportDesde = this.searchForm.get('fecha_aport_desde')?.value;
    if (fechaAportDesde) {
      filtros.push({
        label: ` ${moment(new Date(fechaAportDesde)).format('DD/MM/YYYY')}`,
        campo: 'fecha_aport_desde',
      });
    }

    const fechaAportHasta = this.searchForm.get('fecha_aport_hasta')?.value;
    if (fechaAportHasta) {
      filtros.push({
        label: ` ${moment(new Date(fechaAportHasta)).format('DD/MM/YYYY')}`,
        campo: 'fecha_aport_hasta',
      });
    }

    const docIdentificacion = this.searchForm.get('doc_identificacion')?.value;
    if (docIdentificacion?.trim()) {
      filtros.push({ label: ` ${docIdentificacion.trim()}`, campo: 'doc_identificacion' });
    }

      const codigosLer = this.searchForm.get('codigoLer')?.value as any[];
    if (codigosLer?.length) {
      codigosLer.forEach((c: any) => {
        const label = [c.tipoCodigo, c.descripcion].filter(Boolean).join(' - ');
        filtros.push({ label: (label || String(c)), campo: 'codigoLer', value: c });
      });
    }

    const operaciones = this.searchForm.get('operacionGestion')?.value as any[];
    if (operaciones?.length) {
      operaciones.forEach((o: any) => {
        const label = [o.codigo, o.descripcion].filter(Boolean).join(' - ');
        filtros.push({ label: (label || String(o)), campo: 'operacionGestion', value: o });
      });
    }

    const origenes = this.searchForm.get('origen')?.value as any[];
    if (origenes?.length) {
      origenes.forEach((o: string) => {
        const found = this.origenArray.find((x) => x.value === o);
        filtros.push({ label: found?.label ?? o, campo: 'origen', value: o });
      });
    }

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((estado: any) => {
        filtros.push({
          label: ` ${estado?.descripcionCorta ?? String(estado)}`,
          campo: 'estado',
          value: estado,
        });
      });
    }

    const plataformas = this.searchForm.get('plataformaOrigen')?.value as any[];
    if (plataformas?.length) {
      plataformas.forEach((p: any) => {
        filtros.push({ label: p.descripcion ?? String(p), campo: 'plataformaOrigen', value: p });
      });
    }

    const cargadoPor = this.searchForm.get('cargadoPor')?.value;
    if (cargadoPor) {
      const found = this.cargadoPorArray.find((x: any) => x.id === cargadoPor);
      filtros.push({ label: ` ${found?.name ?? cargadoPor}`, campo: 'cargadoPor' });
    }

    const cantidadDesde = this.searchForm.get('cantidadDesde')?.value;
    if (cantidadDesde !== null && cantidadDesde !== undefined && cantidadDesde !== '') {
      filtros.push({ label: ` ${cantidadDesde}`, campo: 'cantidadDesde' });
    }

    const cantidadHasta = this.searchForm.get('cantidadHasta')?.value;
    if (cantidadHasta !== null && cantidadHasta !== undefined && cantidadHasta !== '') {
      filtros.push({ label: ` ${cantidadHasta}`, campo: 'cantidadHasta' });
    }

const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }
    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'gestor': {
        return this.searchForm.get('gestor') as FormControl;
      }
      case 'poseedor': {
        return this.searchForm.get('poseedor') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  searchData(initPage:boolean = false) {
    if(initPage){
			this.pageNumber = 0;
		}
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
      return;
    }
    const { backendFilter, page, size } = this.getBackendFilter();
    const ordenes = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    let sortValues = ['id,desc'];
    // if (Array.isArray(ordenes) && ordenes.length > 0) {
    //   sortValues = ordenes.map((ordenItem) => `${ordenItem},${String(tipoOrden).toLowerCase()}`);
    // }
    this.spinnerSrv.loadingShow();
    this.aportacionDiAcuerdosGestoresService
      ?.findAll2(backendFilter, {
        page: page,
        size: size,
        sort: sortValues,
      }, ordenes,tipoOrden)
      .subscribe({
        next: (data: PageDTOAportacionDIAcuerdosGestoresDTO) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0 ? true : false;
            this.gridArray = this.canAccessAll(data.datos);
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  // action(element: any) {
  //   if (element.nameButton == 'view') {
  //     this.openModalContributions(element);
  //   } else if (element.nameButton == 'delete') {
  //     this.confirmacionEliminar(element);
  //   } else if (element.nameButton == 'send') {
  //     this.spinnerSrv.loadingShow();
  //     this.aportacionDiAcuerdosGestoresService
  //       .enviarAportacion(element.id)
  //       .subscribe({
  //         next: () => {
  //           this.spinnerSrv.loadingHide();
  //           this.searchData();
  //           this.snackBarSrv.showSnackBar(
  //             'Se ha enviado la aportación correctamente',
  //             'success'
  //           );
  //         },
  //         error: (err) => {
  //           this.spinnerSrv.loadingHide();
  //           console.log(err);
  //         },
  //       });
  //   } else if (element.nameButton == 'accept') {
  //     this.spinnerSrv.loadingShow();
  //     this.aportacionDiAcuerdosGestoresService
  //       .aceptarAportacion(element.id)
  //       .subscribe({
  //         next: () => {
  //           this.spinnerSrv.loadingHide();
  //           this.searchData();
  //           this.snackBarSrv.showSnackBar(
  //             'Se ha aceptado la aportación correctamente',
  //             'success'
  //           );
  //         },
  //         error: (err) => {
  //           this.spinnerSrv.loadingHide();
  //           console.log(err);
  //         },
  //       });
  //   } else if (element.nameButton == 'cancel') {
  //     this.openModalMotivoCancel(element);
  //   }
  // }
  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalContributions(true,false, element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'send') {
      this.spinnerSrv.loadingShow();
      this.aportacionDiAcuerdosGestoresService
        .enviarAportacion(element.id)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha enviado la aportación correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    } else if (element.nameButton == 'accept') {
       this.spinnerSrv.loadingShow();
          // Si superaCupo es true, mostramos aviso de confirmacion antes de aceptar la aportacion.
          this.aportacionDiAcuerdosGestoresService.superaCupo(element.id).subscribe({
            next: (superaCupo: boolean) => {
              if (superaCupo) {
                this.spinnerSrv.loadingHide();
                Swal.fire({
                  text: 'Ha superado las cantidades descritas en el ámbito geográfico del acuerdo. ¿Desea continuar?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Si',
                  cancelButtonText: 'No',
                  allowOutsideClick: false,
                }).then((result: any) => {
                  if (!result.isConfirmed) {
                    return;
                  }
      
                  this.spinnerSrv.loadingShow();
                  this.aportacionDiAcuerdosGestoresService
                    .aceptarAportacion(element.id)
                    .subscribe({
                      next: () => {
                        this.spinnerSrv.loadingHide();
                        this.snackBarSrv.showSnackBar(
                          'Se ha aceptado la aportación correctamente',
                          'success'
                        );
                        this.searchData();
                      },
                      error: (err) => {
                        this.spinnerSrv.loadingHide();
                        console.log(err);
                      },
                    });
                });
                return;
              } else {
                  this.spinnerSrv.loadingShow();
                  this.aportacionDiAcuerdosGestoresService
                    .aceptarAportacion(element.id)
                    .subscribe({
                      next: () => {
                        this.spinnerSrv.loadingHide();
                        this.snackBarSrv.showSnackBar(
                          'Se ha aceptado la aportación correctamente',
                          'success'
                        );
                        this.searchData();
                      },
                      error: (err) => {
                        this.spinnerSrv.loadingHide();
                        console.log(err);
                      },
                    });
              }
            },
            error: (err) => {
              this.spinnerSrv.loadingHide();
              console.log(err);
            },
          });
    } else if (element.nameButton == 'cancel') {
      this.openModalMotivoCancel(element);
    }else if (element.nameButton == 'preview'){
      this.vistaPreviaAportacion(element);
    }else if (element.nameButton == 'correccionEnvalora'){
       this.spinnerSrv.loadingShow();
     this.aportacionDiAcuerdosGestoresService
       .correcionEnvalora(element.id)
       .subscribe({
         next: () => {
           this.spinnerSrv.loadingHide();
           this.searchData();
           this.snackBarSrv.showSnackBar(
             'Se ha actualizado la aportación a corrección Envalora correctamente',
             'success'
           );
         },
         error: (err) => {
           this.spinnerSrv.loadingHide();
           console.log(err);
         },
       });
    }
  }
  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la aportación DI/FS?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarDis(element);
      }
    });
  }

  eliminarDis(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.aportacionDiAcuerdosGestoresService
        .deleteById2(element.id)
        .subscribe({
          next: (value: any) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `La aportación DI/FS se ha eliminado correctamente`,
              'success'
            );
            this.gridArray = this.gridArray.filter(
              (objeto) => objeto.id !== element.id
            );
            this.flagSearch = this.gridArray.length != 0 ? true : false;
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  comboEstados() {
    this.AportacionDIEstadoControllerService.findAll14().subscribe({
      next: (data: Array<AportacionDIEstadoDTO>) => {
        this.estadoArray = data.filter(estado => estado.id !== 6);
      },
      error: () => { },
    });
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  openHolderManagerSelection(cargaMasiva: boolean, esMultipleDI?: any) {
    const dialogRef = this.dialog.open(ManagersAgreementsManagerSelectionDialogComponent, {
      width: '950px',
      maxWidth: '98%',
      maxHeight: '95vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.openModalContributions(cargaMasiva, esMultipleDI, result);
      }
    });
  }

  buscarNimaGestor() {
    // const filtroNimaGestor: SolicitudNimaGestoresDTO = {
    //   fechaAceptacion: this.searchForm.get('fechaAceptacion')?.value,
    // };

    this.aportacionDiAcuerdosGestoresService
      .nimaGestores()
      .subscribe((res: any) => (this.nimaGestorArray = res));
    // this.nimaGestorArray = [{'cargaMasiva': true,
    //   'centro': "Centro Principal Bea",
    //   'id': 139,
    //   'nima': "2814785236",
    //   'razonSocial': "Ges BSL 2605 01"
    // }];
  }

  openModalContributions(isDetailOrElement: boolean | any, esMultipleDI?: boolean, element?: any) {
    const isDetail = typeof isDetailOrElement === 'boolean' ? isDetailOrElement : true;
    const selectedElement = typeof isDetailOrElement === 'boolean' ? element : isDetailOrElement;

    if (!selectedElement && this.puedeEditarAportacionEstadoCorrecionEnvalora()) {
      this.snackBarSrv.showSnackBar(
        'No tiene permisos para crear aportaciones DI/FS.',
        'error'
      );
      return;
    }

    // AI_GESTOR can search but cannot create new contributions.
    if (
      !selectedElement &&
      this.isAiGestorRole() &&
      !this.canViewResource('AI-APORT-AUTOFACT')
    ) {
      this.snackBarSrv.showSnackBar(
        'No tiene permisos para crear aportaciones DI/FS.',
        'error'
      );
      return;
    }

    if (!selectedElement) {
      this.validarGestoresConAcuerdoIndirectoCompletado((gestoresValidos) => {
        this.openModalGestores(gestoresValidos, isDetail, esMultipleDI);
      });
    } else {
      const tipoAportacione = 'Gestores';
      if (isDetail) {
        const dialogRef = this.dialog.open(
          ManagersAgreementsContributionsDisDialogComponent,
          {
            width: '1300px',
            maxWidth: '98%',
            maxHeight: '95vh',
            data: { ...selectedElement, tipoAcceso: tipoAportacione },
            disableClose: true,
          }
        );

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.searchData();
          }
        });
      } else {
        const dialogRef = this.dialog.open(
          IndirectAgreementContributionsDisUploadDialogComponent,
          {
            width: '950px',
            maxWidth: '98%',
            maxHeight: '95vh',
            data: {
              poseedorOrGestor: selectedElement,
              esMultipleDI: esMultipleDI
            },
            disableClose: true,
          }
        );

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.searchData();
          }
        });
      }

    }
  }

  private validarGestoresConAcuerdoIndirectoCompletado(onSuccess: (gestoresValidos: any[]) => void): void {
    this.spinnerSrv.loadingShow();
    const params = new HttpParams().set('page', '0').set('size', '100');

    this.http.get<any>(this.listaGestores, { params }).subscribe({
      next: (response: any) => {
        const datos = Array.isArray(response) ? response : (response?.datos ?? []);
          // const gestoresValidos = (datos ?? []).filter(
          //   (item: any) => item?.tieneAcuerdoIndirectoEstadoCompletado === true
          // );

        const gestoresDisponibles = (datos ?? [])
          .map((item: any) => {
            const gestor = item?.gestorResiduo ?? item?.gestoresResiduos ?? item;
            return {
              id: gestor?.id ?? item?.id,
              nima: gestor?.nima ?? item?.nima,
              razonSocial: gestor?.razonSocial ?? gestor?.obRazonSocial ?? item?.razonSocial ?? item?.obRazonSocial,
              denominacionCentro: gestor?.denominacionCentro ?? gestor?.centro ?? item?.denominacionCentro ?? item?.centro,
            };
          })
          .filter((g: any) => !!g?.id);

        this.spinnerSrv.loadingHide();

        if (gestoresDisponibles.length === 0) {
          this.snackBarSrv.showSnackBar(
            'No puede crear una Aportación DI/FS porque no tiene ningún gestor asociado con acuerdo indirecto.',
            'error'
          );
          return;
        }

        onSuccess(gestoresDisponibles);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'No se ha podido validar los gestores asociados al usuario.',
          'error'
        );
      },
    });
  }

  openModalGestores(gestoresValidos: any[], isDetail: boolean,esMultipleDI?: boolean){
    if (!gestoresValidos?.length) {
      this.snackBarSrv.showSnackBar(
        'No puede crear una Aportación DI/FS porque no tiene ningún gestor asociado con acuerdo indirecto en estado completado.',
        'error'
      );
      return;
    }
    if (gestoresValidos.length > 1) {
      this.openHolderManagerSelection(isDetail, esMultipleDI);
    } else {
      this.openModalContributions(isDetail,
        esMultipleDI,{
        gestorResiduo: {
          id: gestoresValidos[0].id,
          nima: gestoresValidos[0].nima,
          razonSocial: gestoresValidos[0].razonSocial
        },
        estado: { id: 1, descripcion: 'Abierta' },
      });
    }
  }

  canViewResource(rol: string): boolean {
    if (this.authService.hasCurrentUserRole(rol)) {
      return true;
    }
    const altRol = rol.includes('_') ? rol.replace(/_/g, '-') : rol.replace(/-/g, '_');
    return this.authService.hasCurrentUserRole(altRol);
  }

  isAiGestorRole(): boolean {
    return this.canViewResource('AI_GESTOR');
  }

  canCreateAportacionesDiFs(): boolean {
    if (this.puedeEditarAportacionEstadoCorrecionEnvalora()) {
      return false;
    }

    const isEnvGest = this.canViewResource('AI-ENV-GEST');
    const isEnvCons = this.canViewResource('AI-ENV-CONS');

    if (isEnvGest || isEnvCons) {
      return false;
    }

    return this.canViewResource('AI-APORT-AUTOFACT');
  }
  canAccessAll(list: any) {
    const resultView = this.authService.can('acuerdo-indirecto-di', 'view');
    const resultDelete = this.authService.can('acuerdo-indirecto-di', 'delete');

    const resultSend = this.authService.can('acuerdo-indirecto-di', 'update-send');
    const resultAccept = this.authService.can('acuerdo-indirecto-di', 'update-accept');
    const resultCancel = this.authService.can('acuerdo-indirecto-di', 'update-cancel');

    const listPermission = list?.map((objeto: any) => {
      const estado1 = objeto.estado && objeto.estado.id === 1;
      const estado2 = objeto.estado && objeto.estado.id === 2;
      const estado3 = objeto.estado && objeto.estado.id === 3;
      const estado5 = objeto.estado && objeto.estado.id === 5;
      const estado7 = objeto.estado && objeto.estado.id === 7;
      const estado8 = objeto.estado && objeto.estado.id === 8;
      const estado9 = objeto.estado && objeto.estado.id === 9;
      const estado10 = objeto.estado && objeto.estado.id === 10;
      objeto.fechaMAceptacion =
        objeto.fechaAceptacion != null
          ? moment(new Date(objeto.fechaAceptacion)).format('DD/MM/YYYY')
          : null;
      objeto.fechaMAportacion =
        objeto.fechaAportacion != null
          ? moment(new Date(objeto.fechaAportacion)).format('DD/MM/YYYY')
          : null;
      let descripcionMCodLer = objeto.codigoLer ?
        objeto.codigoLer?.tipoCodigo + ' ' + objeto.codigoLer?.descripcion
        : '';
      let descripcionOperacionGes = objeto.operacionGestion ?
        objeto.operacionGestion?.codigo + ' ' + objeto.operacionGestion?.descripcion
        : '';
        const hasDocument = objeto.documento ? true : false;

      return {
        ...objeto,
        canAccessView: resultView,
        canAccessDelete:
          resultDelete &&
          estado1 &&
          objeto.creadoPor == this.authService.getCurrentUserMail(),
        canAccessSend:
          resultSend &&
          estado1 &&
          objeto.creadoPor == this.authService.getCurrentUserMail(),
        canAccessAccept: resultAccept && (estado8 || estado5 || estado9) || (estado10 && this.puedeEditarAportacionEstadoCorrecionEnvalora()),
        canAccessCancel: resultCancel && (estado3 || estado7 || estado8 || estado9 || (estado10 && this.puedeEditarAportacionEstadoCorrecionEnvalora())),
        canAccessPreview: hasDocument,
        descripcionMCodLer: descripcionMCodLer,
        canAccessCorreccionEnvalora: (estado8 || estado3) && this.puedeEditarAportacionEstadoCorrecionEnvalora(),
        descripcionOperacionGes: descripcionOperacionGes,
      };
    });

    return listPermission;
  }
  // canAccessAll(list: any) {
  //   const resultView = this.authService.can('gestores-acuerdo-di', 'view');
  //   const resultDelete = this.authService.can('gestores-acuerdo-di', 'delete');

  //   const resultSend = this.authService.can('gestores-acuerdo-di', 'update-send');
  //   const resultAccept = this.authService.can('gestores-acuerdo-di', 'update-accept');
  //   const resultCancel = this.authService.can('gestores-acuerdo-di', 'update-cancel');

  //   const listPermission = list?.map((objeto: any) => {
  //     const estado1 = objeto.estado && objeto.estado.id === 1;
  //     const estado2 = objeto.estado && objeto.estado.id === 2;
  //     const estado3 = objeto.estado && objeto.estado.id === 3;
  //     const estado5 = objeto.estado && objeto.estado.id === 5;
  //     objeto.fechaMAceptacion =
  //       objeto.fechaAceptacion != null
  //         ? moment(new Date(objeto.fechaAceptacion)).format('DD/MM/YYYY')
  //         : null;
  //     objeto.fechaMAportacion =
  //       objeto.fechaAportacion != null
  //         ? moment(new Date(objeto.fechaAportacion)).format('DD/MM/YYYY')
  //         : null;
  //     let descripcionMCodLer =
  //       objeto.codigoLer.tipoCodigo + ' ' + objeto.codigoLer.descripcion;

  //     return {
  //       ...objeto,
  //       canAccessView: resultView,
  //       canAccessDelete:
  //         resultDelete &&
  //         estado1 &&
  //         objeto.creadoPor == this.authService.getCurrentUserMail(),
  //       canAccessSend:
  //         resultSend &&
  //         estado1 &&
  //         objeto.creadoPor == this.authService.getCurrentUserMail(),
  //       canAccessAccept: resultAccept && (estado2 || estado5),
  //       canAccessCancel: resultCancel && (estado2 || estado3),
  //       descripcionMCodLer: descripcionMCodLer,
  //     };
  //   });

  //   return listPermission;
  // }

  crearAutoFactura() {
    const list = this.gridArray.filter((x) => {
      return x.checked === true;
    });

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        `Debe seleccionar al menos una Aportación DI/FS para generar una prefactura`,
        'error'
      );
      return;
    }
    this.spinnerSrv.loadingShow();
    this.aportacionDiAcuerdosGestoresService
      .generarAutoFactura(list)
      .subscribe({
        next: () => {
          this.snackBarSrv.showSnackBar(
            `La prefactura se ha creado correctamente`,
            'success'
          );
          this.searchData();
          this.spinnerSrv.loadingHide();
        },
        error: (err: any) => {
          console.log(err);
          this.spinnerSrv.loadingHide();
        },
      });
  }

  canAccessNuevoDis(): boolean {
    if (this.puedeEditarAportacionEstadoCorrecionEnvalora()) {
      return false;
    }
    return this.authService.can('acuerdo-indirecto-di', 'create');
  }

  canAccessCargaMasivaDis(): boolean {
    if (this.puedeEditarAportacionEstadoCorrecionEnvalora()) {
      return false;
    }
    return this.authService.can('acuerdo-indirecto-di', 'upload-multiple');
  }

  canAccessCrearAutoFactura(): boolean {
    return this.authService.can('acuerdo-indirecto-di', 'access-autofactura') || this.canViewResource("AI-ENV-GEST");
    //return this.authService.can('gestores-acuerdo-di', 'create') || this.canViewResource("AI-GESTOR");
  }

  // canAccessCargaMasivaDis(): boolean {
  //   return this.authService.can('acuerdo-indirecto-di', 'upload-multiple');
  // }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  
  openModalMotivoCancel(item:any){
    const dialogRef = this.dialog.open(
      ManagersAgreementsContributionsDisDeclineDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: item,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }


  getPoseedorDescription(obj: any) {
    return obj?.razonSocial + ' - ' + obj?.nima + ' - ' + obj?.denominacionCentro;
  }

  getPoseedorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: `${searchterm}`,
    };
  }

  comboEstadosPoseedor() {
    this.poseedorEstadoControllerService.findAll6().subscribe({
      next: (data: any) => {
        this.estadoPoseedorArray = data ?? [];
      },
      error: () => {
        this.estadoPoseedorArray = [];
      },
    });
  }

  comboOrden() {
    this.diccionarioControllerService
      .listarElementos(['ORDEN_ACUERDO_INDIRECTO_APORTACIONES_DI_FS_BUSQUEDA'])
      .subscribe((res: any) => {
        this.orden = res?.['ORDEN_ACUERDO_INDIRECTO_APORTACIONES_DI_FS_BUSQUEDA'] ?? [];
      });
  }

  comboCodigoLer() {
    const backendFilter: CodigoLerFilterDTO = { poseedores: true };
    this.codigoLerControllerService
      .findAll4(backendFilter, { page: 0, size: 1000 })
      .subscribe({
        next: (data: any) => {
          this.codigoLerArray = data?.datos ?? [];
        },
        error: () => {
          this.codigoLerArray = [];
        },
      });
  }
  comboPlataformaOrigen() {
  
    this.plataformaOrigenControllerService
      .findAll6()
      .subscribe({
        next: (data: any) => {
          this.plataformaOrigenArray = data ?? [];
        },
        error: () => {
          this.plataformaOrigenArray = [];
        },
      });
  }
    comboGestoresEstado() {
      this.gestoresResiduosEstadosControllerService.findAll9().subscribe({
        next: (data: any) => {
          this.estadoGestorArray = data ?? [];
        },
        error: () => {
          this.estadoGestorArray = [];
        },
      });
    }
  
  
  buscarOperacionesGestion() {
    const codigoLerIds = (this.searchForm.get('codigoLer')?.value ?? []).map((x: any) => x?.id).filter((x: any) => !!x);
    // if (codigoLerIds.length === 0) {
    //   this.operacionGestionArray = [];
    //   return;
    // }

    const backendFilter: CodigoOperacionFilterDTO = {
      codigoLer: codigoLerIds,
    };
    this.operacionGestionControllerService
      .findByCodigoOperacion(backendFilter, { page: 0, size: 1000 })
      .subscribe({
        next: (data: any) => {
          this.operacionGestionArray = data?.datos ?? [];
        },
        error: () => {
          this.operacionGestionArray = [];
        },
      });
  }
  puedeEditarAportacionEstadoCorrecionEnvalora() {
    return this.canViewResource('AI-APORT-EDIC-TOTAL-ENV-GEST');
  }
    vistaPreviaAportacion(element:any){
      const dialogRef = this.dialog.open(ManagersAgreementsContributionsDisPreviewDialogComponent, {
        width: '98%',
        maxWidth: '98%',
        maxHeight: '95vh',
        data: element,
        disableClose: true,
      });
  }
  confirmacionAutofactura(): void {
    Swal
      .fire({
        text: '¿Desea crear prefactura de las solicitudes seleccionadas en la tabla?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.crearAutofactura();
        }
      });
  }
  crearAutofactura() {
    const list = this.gridArray.filter((x) => x.checked === true);

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        `Debe seleccionar al menos una solicitud para generar una prefactura`,
        'error'
      );
      return;
    }
      this.spinnerSrv.loadingShow();
      this.aportacionDiAcuerdosGestoresService.generarAutoFactura(list)
        .subscribe({
          next: (response: any) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Se ha generado la prefactura correctamente.',
              'success'
            );
            this.searchData();
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            let message = err.error?.arguments[0] ?? 'Ha ocurrido un error al generar la prefactura';
            this.snackBarSrv.showSnackBar(message, 'error');
          },
        });
  }

}
